import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { hippoResourceAtom } from '../recoil/atoms/hippoResourceAtom';

const useHippoText = (): ((
    resourceKey: string,
    replaceTexts?: Record<string, string>
) => string) => {
    const hippoResource = useRecoilValue(hippoResourceAtom);

    const getHippoText = useCallback(
        (resourceKey: string, replaceTexts?: Record<string, string>) => {
            let hippoText = hippoResource[resourceKey] ?? resourceKey;
            if (!replaceTexts) {
                return hippoText;
            }

            Object.entries(replaceTexts).forEach(([key, value]) => {
                hippoText = hippoText.replace(`<${key}>`, value);
            });

            return hippoText;
        },
        [hippoResource]
    );

    return getHippoText;
};

export { useHippoText };
